import {
  Callout,
  IColorCellProps,
  IRenderFunction,
  Stack,
  SwatchColorPicker,
  Text,
} from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { DefaultButton } from '@fluentui/react/lib/Button';
import React, { useState } from 'react';
import { ColorCellsDefault } from './colors';
import { useStyles } from './index.styles';
import { Colors } from 'common/types/globalTypes';

type ColorPickerCalloutProps = {
  onColorChange: (color: string) => void;
  colorCells?: IColorCellProps[];
  columnCount?: number;
  title?: string;
  disabled?: boolean;
  disableCell?: Colors;
};
export const ColorPickerCallout: React.FC<ColorPickerCalloutProps> = ({
  onColorChange,
  colorCells,
  columnCount,
  disabled,
  title,
  disableCell = undefined,
}) => {
  const [isCalloutVisible, setIsCalloutVisible] = useState(false);
  const buttonId = useId('callout-button');
  const labelId = useId('callout-label');
  const descriptionId = useId('callout-description');
  const styles = useStyles();

  const onRenderColorCell: IRenderFunction<IColorCellProps> = (
    props,
    defaultRender
  ) => {
    if (!props) {
      return null;
    }

    const isDisabled = !!disableCell && props.id === disableCell;

    return (
      <div
        style={{
          pointerEvents: isDisabled ? 'none' : 'auto',
        }}
      >
        {defaultRender!(props)}
      </div>
    );
  };

  return (
    <Stack>
      <DefaultButton
        id={buttonId}
        disabled={disabled}
        onClick={() => setIsCalloutVisible(true)}
        text={title ? title : 'Choose Pen Color'}
      />

      {isCalloutVisible && (
        <Callout
          className={styles.callout}
          ariaLabelledBy={labelId}
          ariaDescribedBy={descriptionId}
          gapSpace={0}
          target={`#${buttonId}`}
          onDismiss={() => setIsCalloutVisible(false)}
          setInitialFocus
        >
          <Text block variant="xLarge" className={styles.title} id={labelId}>
            Colors
          </Text>

          <SwatchColorPicker
            columnCount={columnCount ? columnCount : 6}
            cellShape={'square'}
            cellHeight={35}
            cellWidth={35}
            cellBorderWidth={3}
            colorCells={colorCells ? colorCells : ColorCellsDefault}
            onChange={(_, id, color) => {
              onColorChange(color!);
              setIsCalloutVisible(false);
            }}
            onRenderColorCell={onRenderColorCell}
          />
        </Callout>
      )}
    </Stack>
  );
};
